import { columnResizing } from 'prosemirror-tables';

const CELL_MIN_WIDTH = 250;

const columnResizeViewPlugin = columnResizing({ cellMinWidth: CELL_MIN_WIDTH });
const defaultColumnResizeHandlers = columnResizing({}).props.handleDOMEvents;

//removing dom events from plugin in the view mode
columnResizeViewPlugin.props.handleDOMEvents = {
  mousedown: (view, event) => {
    const columnResizingMouseDown = defaultColumnResizeHandlers?.mousedown;
    if (view.editable && columnResizingMouseDown) {
      //@ts-ignore
      return columnResizingMouseDown(view, event);
    }
    return true;
  },
  mousemove: (view, event) => {
    const columnResizingMouseMove = defaultColumnResizeHandlers?.mousemove;
    if (view.editable && columnResizingMouseMove) {
      //@ts-ignore
      return columnResizingMouseMove(view, event);
    }

    return true;
  },
  mouseleave: (view, event) => {
    const columnResizingMouseLeave = defaultColumnResizeHandlers?.mouseleave;
    if (view.editable && columnResizingMouseLeave) {
      //@ts-ignore
      return columnResizingMouseLeave(view, event);
    }

    return true;
  },
};

export default columnResizeViewPlugin;
